<div class="adc-d-flex adc-justify-content-between adc-align-items-center ">
  <ng-content select="[left]"></ng-content>
  <div style="visibility: hidden;"></div>
  <div class="adc-d-flex adc-align-items-center adc-gap-3" >
    <adc-search class="" [data]="searchData" *ngIf="data?.globalSearch == 'true'" (searchVal)="getFilterValue($event)"></adc-search>
    <div class="adc-d-flex adc-align-items-center adc-gap-3">
      <button class="adc-btn adc-btn-primary button adc-gap-2" (click)="openPopup.emit('add')" [ngClass]="{'disabled': data.addDisabled}" *ngIf="data?.globalActionItem[0]?.add == 'true'">
        <span class="material-symbols-outlined adc-pt5">add</span>
      </button>
      <button class="adc-btn adc-btn-primary button adc-gap-2" (click)="openPopup.emit('delete')" [ngClass]="{'disabled' : data.deleteDisabled || selection.selected.length < 1}" *ngIf="data?.globalActionItem[0]?.delete== 'true'">
        <span class="material-symbols-outlined adc-pt5">delete</span>
      </button>
    </div>
    <div class="adc-dropdown" title="{{'Column Manager' | translate}}" #dropdown1 *ngIf="data?.columnManager == 'true'">
      <button class="adc-btn adc-btn-primary button" (click)="showColManager()" [disabled]="data.columnManagerDisabled">
        <span class="material-symbols-outlined">view_column</span>
      </button>
      <div class="adc-dropdown-option-menu adc-rt0 adc-mt5" appendTo="body" *ngIf="showManager">
        <div class="adc-chkgrp-vr adc-bg-white">
          <ng-container *ngFor="let i of columnData; let last = last">
            <div class="adc-chk" *ngIf="i.ColName != 'tableActionItems' && i.label != 'checkbox'">
              <input class="adc-cursor-pointer" type="checkbox" value="" [checked]="i.showColumn" (change)="hideColumn($event, i)"> 
              <label for="{{i.sequenceNumber}}" title="{{i.label | translate}}">
                  {{i.label | translate}}
              </label>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    </div>
  </div>

<div class="adc-w-100 adc-h-100 adc-mb10 adc-mt10" style="position: relative;">
  <div class="adc-border-1 table-container1 adc-w-100">
    <div class="table-responsive">
      <div class="adc-loader2" *ngIf="loading"></div>
      <table mat-table [dataSource]="dataSource" matSort class="adc-table adc-table-striped adc-table-hover adc-border-1 table1" >   
        <ng-container *ngFor="let columnName of this.columnData; let first = first" [matColumnDef]="columnName.ColName"> 
            <div *ngIf="columnName.type == 'checkbox'">
              <th mat-header-cell *matHeaderCellDef class="adc-position-relative">
                <div class="adc-chk adc-justify-content-center">
                  <input type="checkbox" class="adc-m0 border" value="" id="flexCheckDefault1" (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()">
                </div>
              </th>
              <td mat-cell *matCellDef="let row" class="pin-border">
                <div class="adc-chk adc-justify-content-center">
                  <input type="checkbox" class="adc-m0" value="" id="flexCheckDefault1" (click)="$event.stopPropagation()"
                  (change)="handleChange($event, row)"
                  [checked]="selection.isSelected(row)">
                </div>
              </td>
            </div>
            <div *ngIf="columnName.ColName == 'tableActionItems'">
              <th mat-header-cell *matHeaderCellDef>
                {{"Action Items" | translate}}
              </th>
              <td mat-cell *matCellDef="let row" class="pin-border" [style.text-align]="columnName.textAlign == 'right' ? 'right' : columnName.textAlign == 'center' ? 'center' : 'left'">
                <span class="material-symbols-outlined ActionItemIcon adc-cursor-pointer" *ngFor="let icon of data?.actionItemData" (click)="iconActionEvent(icon.actionIcon, row, columnName)" title="{{ icon.actionName | translate }}">{{ icon.actionIcon }}</span>
              </td>
            </div>
            <th mat-header-cell *matHeaderCellDef class="header" [style.padding-left]="first ? '20px': ''"> 
              <div class="adc-d-flex adc-align-items-center adc-gap-2">
                <div class="adc-chk" *ngIf="columnName.dataFormat === 'checkbox'">
                  <input type="checkbox" class="adc-m0" value="" id="flexCheckDefault1" (change)="$event ? masterColToggle() : null"
                  (click)="$event.stopPropagation()" [checked]="selectionRow.hasValue() && isAllColSelected()"
                  [indeterminate]="selectionRow.hasValue() && !isAllColSelected()">
                </div>
                <span class="" mat-sort-header sortActionDescription="Sort by Alert" title="{{ columnName.label | translate}}">{{ columnName.label | translate}}</span>
              </div>
            </th>

            <td style="z-index: 1 !important;" [style.text-align]="columnName.textAlign == 'right' ? 'right' : columnName.textAlign == 'center' ? 'center' : 'left'"
            mat-cell *matCellDef="let element" class="scrollable-text" [style.position]="'relative'" [style.padding-left]="element.depth === 0 && columnName.seqNo === 1 ? '20px' : element.depth !== 0 && columnName.seqNo === 1 ? (element.depth * 10 + 10) + 'px' : ''">
              <span *ngIf="columnName.seqNo === 1 && element.children && element.children.length > 0" 
                [ngStyle]="{'position': 'absolute', 'left': element.depth === 0 ? '0px' : (element.depth || 0) * 10 - 10 + 'px'}">
                <mat-icon (click)="toggleRow(element)" class="chevron-icon">
                    {{ element.isExpanded ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </span> 
              <span *ngIf="columnName.dataFormat === 'link'" (click)="openColLink(element, columnName)" class="showLink" title="{{element[columnName.ColName]}}">{{element[columnName.ColName]}}</span>
              <span *ngIf="columnName.dataFormat === 'uppercase'" title="{{element[columnName.ColName] | uppercase}}">{{element[columnName.ColName] | uppercase}}</span>
              <span *ngIf="columnName.dataFormat === 'titlecase'" title="{{element[columnName.ColName] | titlecase}}">{{element[columnName.ColName] | titlecase}}</span>
              <span *ngIf="columnName.dataFormat === 'percent'" title="{{ element[columnName.ColName] }} ({{ element[columnName.ColName] | percent }})">{{ element[columnName.ColName] }} ({{ element[columnName.ColName] | percent }})</span>
              <span *ngIf="columnName.dataFormat != 'uppercase' && columnName.dataFormat != 'titlecase' && columnName.dataFormat != 'percent' && columnName.dataFormat != 'link'" title="{{element[columnName.ColName]}}">{{element[columnName.ColName]}}</span>
              <span *ngIf="columnName.dataFormat === 'checkbox'">
                <div class="adc-chk">
                  <input type="checkbox" class="adc-m0" value="" (click)="$event.stopPropagation()"
                  [checked]="selectionRow.isSelected(element)" (change)="handleColChange($event, element)">
                </div>
              </span>
            </td>
            
            
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row adc-ws-nowrap" *matNoDataRow>
            <!-- <h5 class="adc-m10 adc-p0 adc-text-center loader" *ngIf="dataSource.filteredData.length == 0 && noData == false"><div class="adc-loader1"></div></h5> -->
            <h5 class="adc-m10 adc-p0 adc-text-center loader" *ngIf="noData">{{"No Data Found" | translate}}</h5>
          </tr>
      </table>
      <div class="skeleton-loader" *ngIf="dataSource.filteredData.length == 0 && noData == false">
        <div class="skeleton-body" *ngFor="let item of skeletonRows">
          <div class="skeleton-row">
            <ng-container *ngFor="let column of columnData; let i = index">
              <div class="skeleton-cell" *ngIf="i > 0"></div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  